import React, { useEffect } from 'react';
import highwayItems from '../config/highway.json';
import { SelectableBoxField, TextField } from '@flos/react-ui';
import { HighwayItem } from '../types/highway';

type HighwayProps = {
    basePath: string;
};

type FormOption = {
    label: string;
    value: string;
    description: string | JSX.Element;
    iconShape: string;
};

const Highway = ({ basePath }: HighwayProps) => {
    const [claimFilter, setClaimFilter] = React.useState('');
    const [claimFormsCount, setClaimFormCount] = React.useState(0);
    const [matchingHighwayItems, setMatchingHighwayItems] = React.useState<FormOption[]>([]);

    // Casting to allow the JSON to be interpreted correctly
    // Not ideal
    const highwayItems2 = highwayItems as HighwayItem[];

    useEffect(() => {
        setClaimFormCount(highwayItems2.length);
    }, [highwayItems2.length]);

    useEffect(() => {
        const options: FormOption[] = [];

        highwayItems2.forEach((highwayItem) => {
            const { formId, caption, tags } = highwayItem;

            let keep = 0;
            if (claimFilter.length > 0) {
                if (tags.includes('*')) {
                    keep = 1;
                } else {
                    const parts = claimFilter.split(/\s+/);

                    parts.forEach((word) => {
                        // Find any matching tags
                        if (word !== ' ' && tags.includes(word)) {
                            keep = 2;
                        }

                        // Find any matching formId
                        if (formId.includes(word)) {
                            keep = 3;
                        }
                    });
                }
            } else {
                keep = 4;
            }

            if (!keep) {
                return;
            }

            let icon = '';

            if (highwayItem.icon !== undefined) {
                icon = highwayItem.icon;
            } else {
                icon = 'document';
            }

            let tagsString = tags.join(', ');

            options.push({
                label: `${formId}`,
                description: (
                    <div>
                        <div>{caption}</div>
                        <div style={{ fontSize: '0.9em', fontStyle: 'italic', fontWeight: 'lighter' }}>
                            Tags: {tagsString}
                        </div>
                    </div>
                ),
                value: formId,
                iconShape: icon
            });
        });

        setMatchingHighwayItems(options);
        setClaimFormCount(options.length);
    }, [claimFilter, highwayItems2]);

    const handleFilterChange = (filter: string) => {
        setClaimFilter(filter);
    };

    return (
        <div id="container">
            <br />
            <TextField
                value={claimFilter}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const value = event.target.value;
                    handleFilterChange(value);
                }}
                id="chatForm"
                key="chatForm"
                label="Filter by tags or form ID"
                data-testid="textfield"
                helpText="E.g. 'rejse dyr' to filter by the tags 'rejse' and 'dyr', or 'andet-' to filter by all form IDs that contains 'andet-'."
            />

            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                Number of matching claim forms: {claimFormsCount}
            </div>

            <SelectableBoxField
                label=""
                value=""
                onChangeValue={(formId: string) => {
                    // We are not inside <Routes>
                    // so redirect() will not work here
                    document.location.href = basePath + (basePath.match(/\/$/) ? '' : '/') + formId;
                }}
                options={matchingHighwayItems}
            />
        </div>
    );
};

export default Highway;
